<div class="preloader-wrapper" [hidden]="!loading">
    <div class="preloader wow"  data-wow-duration="2s" data-wow-delay="5s">
    </div>
</div>
